import { useEffect } from 'react';
import * as React from 'react';

import SurveyStep, { SurveyStepProps } from './SurveyStep';

type Props = {
  closeSurvey?: () => void;
} & SurveyStepProps;

const SurveyFinishStep: React.FC<React.PropsWithChildren<Props>> = ({
  closeSurvey,
  ...stepProps
}) => {
  useEffect(() => {
    if (closeSurvey) {
      const timeoutId = setTimeout(closeSurvey, 4000);

      return (): void => clearTimeout(timeoutId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <SurveyStep {...stepProps} />;
};

export default SurveyFinishStep;
